import { TefComs4p } from '@mfe/components/TefComs4p';
import { renderSinglePurposeConsents } from '@mfe/components/templates/occl/TefComs4p/singlePurposeEdit.tmpl';
import { Purpose } from '@mfec/types/model';
import { html } from 'lit';

//
// renders a single purpose block
//
// {Purpose name}
// {Purpose description}
//   {subscription BLOCK}
export const singlePurposeEdit = function render(this: TefComs4p, purpose : Purpose) {
  return html`
    <one-heading level="h6" variant="default">${purpose.title}</one-heading>
    <one-text as="p">
      ${purpose.shortDescription} ${this.getTemplateFn('tefPurposeDescriptionModal')(purpose)}
    </one-text>
    ${renderSinglePurposeConsents(this, purpose)}
  `;
};
